const BASE_BAN = { w: 60, h: 100, rx: 16, ry: 16 };
const SPARE_BAN = { w: 70, h: 70, rx: 30, ry: 30 };

const addLine = (lines, x1, y1, x2, y2) => {
  lines.push({ x1, y1, x2, y2 });
};

const addBan = (bans, id, x, y, style = BASE_BAN) => {
  bans.push({ id, label: id, x, y, ...style });
};

export function getFormasiBanViewHeight(formasi) {
  const value = Number(formasi || 0);
  if (value <= 6) return 310;
  if (value <= 10) return 430;
  if (value <= 14) return 540;
  if (value === 16) return 750;
  if (value <= 18) return 650;
  if (value <= 22) return 750;
  return 750;
}

export function getFormasiBanLayout(formasi, cadangan) {
  const value = Number(formasi || 0);
  const spare = Number(cadangan || 0);
  const lines = [];
  const bans = [];

  if (value === 16) {
    addLine(lines, 95, 70, 295, 70);
    addLine(lines, 210, 70, 210, 240);
    addLine(lines, 95, 240, 295, 240);
    addLine(lines, 210, 240, 210, 350);
    addLine(lines, 95, 350, 295, 350);
    addLine(lines, 210, 350, 210, 460);
    addLine(lines, 95, 460, 330, 460);
    addLine(lines, 210, 460, 210, 570);
    addLine(lines, 95, 570, 330, 570);
    addLine(lines, 210, 570, 210, 680);
    addLine(lines, 95, 680, 330, 680);

    addBan(bans, "P-01", 70, 20);
    addBan(bans, "P-02", 285, 20);
    addBan(bans, "P-03", 35, 190);
    addBan(bans, "P-04", 100, 190);
    addBan(bans, "P-05", 255, 190);
    addBan(bans, "P-06", 320, 190);
    addBan(bans, "P-07", 35, 300);
    addBan(bans, "P-08", 100, 300);
    addBan(bans, "P-09", 255, 300);
    addBan(bans, "P-10", 320, 300);

    addBan(bans, "P-11", 35, 410, { ...BASE_BAN, w: 70 });
    addBan(bans, "P-12", 310, 410, { ...BASE_BAN, w: 70 });
    addBan(bans, "P-13", 35, 520, { ...BASE_BAN, w: 70 });
    addBan(bans, "P-14", 310, 520, { ...BASE_BAN, w: 70 });
    addBan(bans, "P-15", 35, 630, { ...BASE_BAN, w: 70 });
    addBan(bans, "P-16", 310, 630, { ...BASE_BAN, w: 70 });
  } 
  else if(value === 8){
    addLine(lines, 95, 70, 295, 70);
    addLine(lines, 210, 70, 210, 240);
    addLine(lines, 95, 240, 295, 240);
    addLine(lines, 210, 240, 210, 350);
    addLine(lines, 95, 350, 295, 350);
    
    addBan(bans, "P-01", 70, 20);
    addBan(bans, "P-02", 285, 20);
    addBan(bans, "P-03", 70, 190);
    addBan(bans, "P-04", 285, 190);
    addBan(bans, "P-05", 35, 300);
    addBan(bans, "P-06", 100, 300);
    addBan(bans, "P-07", 255, 300);
    addBan(bans, "P-08", 320, 300);
  }
  else {
    addLine(lines, 95, 70, 295, 70);
    addLine(lines, 210, 70, 210, 240);
    addLine(lines, 95, 240, 295, 240);

    addBan(bans, "P-01", 70, 20);
    addBan(bans, "P-02", 285, 20);
    addBan(bans, "P-03", 35, 190);
    addBan(bans, "P-04", 100, 190);
    addBan(bans, "P-05", 255, 190);
    addBan(bans, "P-06", 320, 190);

    if (value > 6) {
      addLine(lines, 210, 240, 210, 350);
      addLine(lines, 95, 350, 295, 350);
      addBan(bans, "P-07", 35, 300);
      addBan(bans, "P-08", 100, 300);
      addBan(bans, "P-09", 255, 300);
      addBan(bans, "P-10", 320, 300);
    }

    if (value > 10) {
      addLine(lines, 210, 350, 210, 460);
      addLine(lines, 95, 460, 295, 460);
      addBan(bans, "P-11", 35, 410);
      addBan(bans, "P-12", 100, 410);
      addBan(bans, "P-13", 255, 410);
      addBan(bans, "P-14", 320, 410);
    }

    if (value > 14) {
      addLine(lines, 95, 570, 295, 570);
      addLine(lines, 210, 460, 210, 570);
      addBan(bans, "P-15", 35, 520);
      addBan(bans, "P-16", 100, 520);
      addBan(bans, "P-17", 255, 520);
      addBan(bans, "P-18", 320, 520);
    }

    if (value > 18) {
      addLine(lines, 210, 570, 210, 680);
      addLine(lines, 95, 680, 295, 680);
      addBan(bans, "P-19", 35, 630);
      addBan(bans, "P-20", 100, 630);
      addBan(bans, "P-21", 255, 630);
      addBan(bans, "P-22", 320, 630);
    }
  }

  // Susunan baru ban cadangan:
  // S-3 pindah ke posisi lama S-1, lalu S-2 sedikit di atas S-3, dan S-1 sedikit di atas S-2.
  if (spare > 0) addBan(bans, "S-1", 173, 130, SPARE_BAN);
  if (spare > 1) addBan(bans, "S-2", 173, 205, SPARE_BAN);
  if (spare > 2) addBan(bans, "S-3", 173, 315, SPARE_BAN);

  return { lines, bans };
}
